import React from 'react';
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';

import './Services.css';
import { SubHeading } from '../../components/SubHeading/SubHeading';
import { services } from '../../constants/data';

export const Services = () => {
  const scrollRef = React.useRef(null);

  const scroll = (direction) => {
    const { current } = scrollRef;

    if (direction === 'left') {
      current.scrollLeft -= 300;
    } else {
      current.scrollLeft += 300;
    }
  };

  return (
    <div className="app__services flex__center">
      <div className="app__services-content">
        <SubHeading title="Our Services" />
        <h1 className="headtext__cormorant">Offered Services a call away</h1>
        <p className="p__opensans" style={{ color: '#000000', marginTop: '2rem' }}>Here are the services we offer to everyone, on call, and at all times. Click card to view details</p>
        {/* <button type="button" className="custom__button">View More</button> */}
      </div>
      <div className="app__services-images">
        <div className="app__services-images_container" ref={scrollRef}>
          {services.map((s, index) => (
            <div className="app__services-images_card flex__center" key={`services_image-${index + 1}`}>
              <img src={s.image} alt="services_image" />
              <div className="services__image-icon" >
                <p>{s.title}</p>
                {/* <div>

                <BsInstagram />
                    </div> */}
              </div>
            </div>
          ))}
        </div>
        <div className="app__services-images_arrows">
          <BsArrowLeftShort className="services__arrow-icon" onClick={() => scroll('left')} />
          <BsArrowRightShort className="services__arrow-icon" onClick={() => scroll('right')} />
        </div>
      </div>
    </div>
  );
};

// export default Gallery;
